import { createFileRoute, useParams } from "@tanstack/react-router";

import { useEvent } from "@/hooks/queries/use-events-query";

import { BookingPage } from "./-components/booking.page";

export const Route = createFileRoute("/booking/$eventId")({
  component: Page,
  validateSearch: (search) => {
    if (search.ticketTier) return { ticketTier: search.ticketTier };
  }
});

function Page() {
  const { eventId } = useParams({ from: "/booking/$eventId" });
  const { data, isLoading, error } = useEvent(eventId);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background-primary flex items-center justify-center">
        <div className="text-text-primary">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-background-primary flex items-center justify-center">
        <div className="text-text-primary">Error loading event: {error.message}</div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="min-h-screen bg-background-primary flex items-center justify-center">
        <div className="text-text-primary">Event not found</div>
      </div>
    );
  }

  return <BookingPage event={data} />;
}
